import { array, boolean, Lazy, lazy, mixed, object, Schema } from 'yup';

import {
  AmazonPaymentServiceConfig,
  ApplePaymentServiceConfig,
  GooglePaymentServiceConfig,
  Store,
  StoreHelpers,
} from '@playq/services-bookkeeper';
import { OneSignalConfigurationSerialized } from '@playq/services-sonar';

import { fieldRequiredSchema } from '/helpers/fieldRequiredSchema';

const verificationConfigSchema = object().shape({
  verificationUri: fieldRequiredSchema('Verification Uri'),
});

export const oneSignalSchema: Schema = object().shape({
  restApiToken: fieldRequiredSchema('RestApi Token'),
  appId: fieldRequiredSchema('AppId'),
});

export const amazonConfigSchema = verificationConfigSchema.concat(
  object().shape({
    developerSecret: fieldRequiredSchema('Developer Secret'),
  })
);

export const appleConfigSchema = verificationConfigSchema.concat(
  object().shape({
    additionalIds: array().of(fieldRequiredSchema('Additional ID')),
  })
);

export const googleConfigSchema = verificationConfigSchema.concat(
  object().shape({
    clientId: fieldRequiredSchema('Client Id'),
    clientSecret: fieldRequiredSchema('Client Secret'),
    tokenRefreshUri: fieldRequiredSchema('Token Refresh Uri'),
    refreshToken: fieldRequiredSchema('Refresh Token'),
  })
);

const verificationConfigsSchemaMap = {
  [Store.AmazonMarketplace]: object().shape({
    [AmazonPaymentServiceConfig.FullClassName]: amazonConfigSchema,
  }),
  [Store.AppStore]: object().shape({
    [ApplePaymentServiceConfig.FullClassName]: appleConfigSchema,
  }),
  [Store.GooglePlay]: object().shape({
    [GooglePaymentServiceConfig.FullClassName]: googleConfigSchema,
  }),
};

const verificationSchema: Schema<object> = object().shape(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  StoreHelpers.all.reduce((map: { [store: string]: Lazy<any> }, store: Store) => {
    map[store] = lazy((value: string) => {
      return value !== undefined ? verificationConfigsSchemaMap[store] : mixed().notRequired();
    });
    return map;
  }, {})
);

export const sonarConfigSchema: Schema = object().shape({
  oneSignal: lazy((value?: OneSignalConfigurationSerialized) => (value ? oneSignalSchema : mixed().notRequired())),
});

export const bookkeeperConfigSchema: Schema<object> = object().shape({
  ignorePaymentFailures: boolean().required(),
  ignorePaymentValidation: boolean().required(),
  allowPaymentsMigration: boolean().required(),
  anchorCurrency: fieldRequiredSchema('Anchor Currency'),
  verificationConfigs: verificationSchema,
});

export const fgpConfigSchema: Schema<object> = object().shape({
  integrations: object().shape({
    facebook: object().shape({
      token: fieldRequiredSchema('App Secret'),
      additionalIds: array().of(fieldRequiredSchema('Additional App secret')),
    }),
    apple: object().shape({
      additionalIds: array().of(fieldRequiredSchema('Additional ClientId')),
    }),
    google: object().shape({
      additionalIds: array().of(fieldRequiredSchema('Additional ClientId')),
    }),
  }),
});
